// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionTab_wrapper__Go0ie","text":"SectionTab_text__Ih2qg","active":"SectionTab_active__5HX2l"};